"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Enable = void 0;
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var react_1 = __importDefault(require("react"));
var styles = __importStar(require("./PaymentsSettings.css"));
var usePaymentSettings_1 = require("Library/PaymentsDashboard/PaymentSettings/usePaymentSettings");
var Enable = function () {
    var _a = (0, usePaymentSettings_1.usePaymentSettings)(), settings = _a.settings, updater = _a.updater;
    return (react_1.default.createElement(kaleidoscope_1.Card, { className: styles.settingsCard },
        react_1.default.createElement(kaleidoscope_1.Stack, { gap: "xl" },
            react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", align: "center", justify: "spaceBetween", gap: "xl" },
                react_1.default.createElement("div", null,
                    react_1.default.createElement(kaleidoscope_1.Text, { element: "div", size: "s", strong: true }, "Enable Payments for your account"),
                    react_1.default.createElement(kaleidoscope_1.Text, { element: "div", size: "xs", secondary: true }, "This controls payments across all pages on your account. Turn this off if you want to pause payments without having to disconnect your gateway.")),
                react_1.default.createElement("div", null,
                    react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", align: "center", justify: "end" },
                        react_1.default.createElement("div", null,
                            react_1.default.createElement(kaleidoscope_1.Toggle, { labelHidden: true, disabled: false, key: "key", label: "label", value: settings.enabled, onChange: function (val) { return updater({ enabled: val }); } }))))))));
};
exports.Enable = Enable;
